import React, { lazy, FC } from 'react'
import { RouteObject } from 'react-router'
import { useRoutes } from 'react-router-dom'
import { WrapperRouteComponent, WrapperRouteWithOutLayoutComponent } from './config'
import LoginPage from '../pages/login'
import LayoutPage from '../pages/layout'
import Empty from '../components/empty'

const DashboardLearn = lazy(() => import('../pages/dashboard/learn'))
const DashboardPreach = lazy(() => import('../pages/dashboard/preach'))

const LearnPlan = lazy(() => import('../pages/learn/plan'))
const LearnPlanDetail = lazy(() => import('../pages/learn/plan/detail'))
const LearnCheck = lazy(() => import('../pages/learn/check'))
const LearnCheckDetail = lazy(() => import('../pages/learn/check/detail'))
const LearnManager = lazy(() => import('../pages/learn/manager'))
const LearnManagerMaterial = lazy(() => import('../pages/learn/manager/material'))
const LearnManagerMaterialDetail = lazy(() => import('../pages/learn/manager/material/detail'))
const LearnState = lazy(() => import('../pages/learn/state'))
const LearnStateTaskReport = lazy(() => import('../pages/learn/state/task_report'))
const LearnStateCheck = lazy(() => import('../pages/learn/state/check'))

const PreachTeam = lazy(() => import('../pages/preach/team'))
const PreachPlan = lazy(() => import('../pages/preach/plan'))
const PreachPlanDetail = lazy(() => import('../pages/preach/plan/detail'))
const PreachCheck = lazy(() => import('../pages/preach/check'))
const PreachCheckId = lazy(() => import('../pages/preach/check_id'))
const PreachCheckDetail = lazy(() => import('../pages/preach/check/detail'))
const PreachTaskCheck = lazy(() => import('../pages/preach/task_check'))
const PreachTaskCheckDetail = lazy(() => import('../pages/preach/task_check/detail'))
const PreachTaskCheckReport = lazy(() => import('../pages/preach/task_check/report'))
const PreachTaskCheckReportDetail = lazy(() => import('../pages/preach/task_check/report/detail'))

const MaterialManager = lazy(() => import('../pages/material/manager'))
const AccountManager = lazy(() => import('../pages/account/manager'))
const AccountConfig = lazy(() => import('../pages/account/config'))

//unit
const UnitLearnPlan = lazy(() => import('../pages/unit/learn/plan'))
const UnitLearnPlaDetail = lazy(() => import('../pages/unit/learn/plan/detail'))
const UnitLearnTaskReport = lazy(() => import('../pages/unit/learn/task_report'))
const UnitLearnTaskDetail = lazy(() => import('../pages/unit/learn/task_report/task_detail'))
const UnitLearnTaskReportForm = lazy(() => import('../pages/unit/learn/task_report/task_report_form'))
const UnitLearnReport = lazy(() => import('../pages/unit/learn/learn_report'))
const UnitLearnReportForm = lazy(() => import('../pages/unit/learn/learn_report/learn_report_form'))

const UnitPreachPlan = lazy(() => import('../pages/unit/preach/plan'))
const UnitPreachPlaDetail = lazy(() => import('../pages/unit/preach/plan/detail'))

const UnitPreachTeam = lazy(() => import('../pages/unit/preach/team'))
const UnitPreachTask = lazy(() => import('../pages/unit/preach/task'))
const UnitPreachTaskDetail = lazy(() => import('../pages/unit/preach/task/task_detail'))

const UnitPreachReport = lazy(() => import('../pages/unit/preach/report'))

const UnitMaterial = lazy(() => import('../pages/unit/material'))

const routeList = [
	{
		path: '/',
		element: <WrapperRouteComponent element={<LayoutPage />} titleId="" auth />,
		children: [
			{
				path: 'dashboard/learn',
				element: <WrapperRouteComponent element={<DashboardLearn />} titleId="学习统计" auth />
			},
			{
				path: 'dashboard/preach',
				element: <WrapperRouteComponent element={<DashboardPreach />} titleId="宣讲统计" auth />
			},
			{
				path: 'learn/plan',
				element: <WrapperRouteComponent element={<LearnPlan />} titleId="年度学习计划" auth />
			},
			{
				path: 'learn/plan/detail/:id',
				element: <WrapperRouteComponent element={<LearnPlanDetail />} titleId="年度学习计划材料" auth />
			},
			{
				path: 'learn/check',
				element: <WrapperRouteComponent element={<LearnCheck />} titleId="自主上报审核" auth />
			},
			{
				path: 'learn/check/detail/:id',
				element: <WrapperRouteComponent element={<LearnCheckDetail />} titleId="单位上报材料" auth />
			},
			{
				path: 'learn/manager',
				element: <WrapperRouteComponent element={<LearnManager />} titleId="学习任务管理" auth />
			},
			{
				path: 'learn/manager/material/:id',
				element: <WrapperRouteComponent element={<LearnManagerMaterial />} titleId="查看上报材料" auth />
			},
			{
				path: 'learn/manager/material/detail/:id',
				element: <WrapperRouteComponent element={<LearnManagerMaterialDetail />} titleId="单位上报材料" auth />
			},
			{
				path: 'learn/state',
				element: <WrapperRouteComponent element={<LearnState />} titleId="学习情况查看" auth />
			},
			{
				path: 'learn/state/task_report/:id',
				element: <WrapperRouteComponent element={<LearnStateTaskReport />} titleId="学习任务查看" auth />
			},
			{
				path: 'learn/state/check/:id',
				element: <WrapperRouteComponent element={<LearnStateCheck />} titleId="学习自主上报查看" auth />
			},
			{
				path: 'preach/team',
				element: <WrapperRouteComponent element={<PreachTeam />} titleId="宣讲情况查看" auth />
			},
			{
				path: 'preach/plan',
				element: <WrapperRouteComponent element={<PreachPlan />} titleId="年度宣讲计划" auth />
			},
			{
				path: 'preach/plan/detail/:id',
				element: <WrapperRouteComponent element={<PreachPlanDetail />} titleId="年度学宣讲计划材料" auth />
			},
			{
				path: 'preach/check',
				element: <WrapperRouteComponent element={<PreachCheck />} titleId="宣讲自主上报审核" auth />
			},
			{
				path: 'preach/check_id/:id',
				element: <WrapperRouteComponent element={<PreachCheckId />} titleId="宣讲自主上报审核" auth />
			},
			{
				path: 'preach/check/detail/:id',
				element: <WrapperRouteComponent element={<PreachCheckDetail />} titleId="宣讲自主上报详情" auth />
			},
			{
				path: 'preach/task_check',
				element: <WrapperRouteComponent element={<PreachTaskCheck />} titleId="宣讲任务审核" auth />
			},
			{
				path: 'preach/task_check/detail/:id',
				element: <WrapperRouteComponent element={<PreachTaskCheckDetail />} titleId="宣讲任务详情" auth />
			},
			{
				path: 'preach/task_check/report/:id',
				element: <WrapperRouteComponent element={<PreachTaskCheckReport />} titleId="宣讲任务上报情况" auth />
			},
			{
				path: 'preach/task_check/report/detail/:id',
				element: <WrapperRouteComponent element={<PreachTaskCheckReportDetail />} titleId="宣讲任务上报详情" auth />
			},
			{
				path:'material/manager',
				element: <WrapperRouteComponent element={<MaterialManager />} titleId="学习资料管理" auth />
			},
			{
				path: 'account/manager',
				element: <WrapperRouteComponent element={<AccountManager />} titleId="学习账号管理" auth />
			},
			{
				path: 'account/config',
				element: <WrapperRouteComponent element={<AccountConfig />} titleId="预警设置" auth />
			},



			//unit

			{
				path: 'unit',
				children:[
					{
						path: 'dashboard/learn',
						element: <WrapperRouteComponent element={<DashboardLearn />} titleId="学习统计" auth />
					},
					{
						path: 'dashboard/preach',
						element: <WrapperRouteComponent element={<DashboardPreach />} titleId="宣讲统计" auth />
					},
					{
						path: 'learn/plan',
						element: <WrapperRouteComponent element={<UnitLearnPlan />} titleId="年度学习计划" auth />
					},
					{
						path: 'learn/plan/detail/:id',
						element: <WrapperRouteComponent element={<UnitLearnPlaDetail />} titleId="年度学习计划详情" auth />
					},
					{
						path: 'learn/task_report',
						element: <WrapperRouteComponent element={<UnitLearnTaskReport />} titleId="学习任务列表" auth />
					},
					{
						path: 'learn/task_report/detail/:id',
						element: <WrapperRouteComponent element={<UnitLearnTaskDetail />} titleId="学习任务详情" auth />
					},
					{
						path: 'learn/task_report/form/:id/edit',
						element: <WrapperRouteComponent element={<UnitLearnTaskReportForm />} titleId="学习任务上报" auth />
					},
					{
						path: 'learn/report',
						element: <WrapperRouteComponent element={<UnitLearnReport />} titleId="自主学习上报列表" auth />
					},
					{
						path: 'learn/report/form/create',
						element: <WrapperRouteComponent element={<UnitLearnReportForm />} titleId="自主学习上报" auth />
					},
					{
						path: 'learn/report/form/:id/edit',
						element: <WrapperRouteComponent element={<UnitLearnReportForm />} titleId="自主学习上报" auth />
					},

					{
						path: 'preach/team/build',
						element: <WrapperRouteComponent element={<UnitPreachTeam />} titleId="宣讲队伍建设" auth />
					},
					{
						path: 'preach/task',
						element: <WrapperRouteComponent element={<UnitPreachTask />} titleId="理论宣讲任务" auth />
					},
					{
						path: 'preach/plan',
						element: <WrapperRouteComponent element={<UnitPreachPlan />} titleId="年度宣讲计划" auth />
					},
					{
						path: 'preach/plan/detail/:id',
						element: <WrapperRouteComponent element={<UnitPreachPlaDetail />} titleId="年度宣讲计划详情" auth />
					},
					{
						path: 'preach/task/detail/:id',
						element: <WrapperRouteComponent element={<UnitPreachTaskDetail />} titleId="理论宣讲任务详情" auth />
					},
					{
						path: 'preach/report',
						element: <WrapperRouteComponent element={<UnitPreachReport />} titleId="宣讲自主上报" auth />
					},
					{
						path: 'material/manager',
						element: <WrapperRouteComponent element={<UnitMaterial />} titleId="学习宣讲资料" auth />
					},
				]
			},

		]
	},
	{
		path: 'login',
		element: <WrapperRouteWithOutLayoutComponent element={<LoginPage />} titleId="登录" />
	},
	{
		path: '*',
		element: (
			<WrapperRouteWithOutLayoutComponent
				element={<Empty title="找不到咯" description="这里什么也没有~" type="404" />}
				titleId="404"
			/>
		)
	}
]

const RenderRouter = () => {
	const element = useRoutes(routeList)
	return element
}

export default RenderRouter
